import domready from 'domready'
import StoryController from './controllers/story-controller'

export default function initStoryController () {
  domready(() => {
    const storyElement = document.querySelector('.story')
    if (storyElement) {
      console.log('initiating story controller', storyElement)
      // eslint-disable-next-line no-new
      new StoryController(storyElement)
    }
  })
}
